<template>
  <div>
    <common-dialog
      ref="dialog"
      width="995px"
      unit="资源档案"
      id-key="RecordId"
      :data="data"
      :get-data-func="api.info"
      :form-rules="rules"
      :save-func="api.save"
      @create-opened="onCreateOpened"
      @details-opened="onDetailsOpened"
      :before-save="onBeforeSave"
      close-on-saved
      form-label-width="85px"
      @close-saved="$emit('close-saved')"
      @closed="onClosed"
    >
      <template slot="form">
        <el-row>
          <el-col :span="24">
            <el-form-item label="资源标题" prop="InfoTitle">
              {{ data.InfoTitle }}
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="资源类别" prop="InfotypeId">
              {{ data.TypeName }}
            </el-form-item>
          </el-col>
         
         
          <el-col :span="24">
            <el-divider>资源详情</el-divider>
            <div v-html="data.InfoContent"></div>
            <el-divider></el-divider>
          </el-col>
          <el-col :span="24">
            <el-form-item label="资源简介" prop="InfoBrief">
              {{ data.InfoBrief }}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="isMB?'':'缩略图'" :label-width="isMB?'0':''" prop="PhotoAddress">
              <el-divider v-if="isMB">缩略图</el-divider>
              <single-pic-upload
                v-model="data.PhotoAddress"
                type="PhotoAddress"
                :uploadUrl="uploadUrl"
                IsDetail
              ></single-pic-upload>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:6">
            <el-form-item label="发布时间" prop="ReleaseTime">
              {{ $commonJs.toDatetimeString(data.ReleaseTime) }}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="是否置顶" prop="IfTop">
              {{ data.IfTop==1?"是":"否" }}
            </el-form-item>
          </el-col>
         
         
        </el-row>
        <el-row>
          <el-col :span="isMB?24:16" style="padding-left:17px;">
            <div style="margin-bottom:6px;">审核日志</div>
            <el-table :data="tableData" border size="small">
              <el-table-column prop="UserName" label="操作人" />
              <el-table-column prop="OperResult" label="操作结果">
                <template slot-scope="{row}">
                  <span v-if="row.OperResult==1">提交</span>
                  <span v-else-if="row.OperResult==2">通过</span>
                  <span v-else-if="row.OperResult==3">不通过</span>
                  <span v-else-if="row.OperResult==4">撤销审核</span>
                </template>
              </el-table-column>
              <el-table-column prop="OperMsg" label="备注" />
              <el-table-column prop="OperTime" label="操作时间" />
            </el-table>
          </el-col>
        </el-row>
      </template>
      <template slot="footer">
        <template v-if="$permission.canReview()">
          <template v-if="data.State==1">
            <el-button type="success" @click="pass">通 过</el-button>
            <el-button type="danger" @click="noPass">不通过</el-button>
          </template>
          <el-button type="warning" v-else-if="data.State==2" @click="cancel">撤销审核</el-button>
        </template>
        <el-button @click="close">关闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>

import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import singlePicUpload from "@/components/common/photo/singleUpload";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    singlePicUpload,
  },
  computed: {
    host() {
      return window.location.origin;
    }
  },
  data() {
    return {
      data: {
        RecordId: 0,
        OrderId: 0,
        InfoTitle:"",
        InfotypeId: null,
        TypeName: "",
      
        InfoContent: "",
       
        InfoBrief: "",
        IfTop: 1,
        PhotoAddress: "",
        ReleaseTime: "",
       
        State: 0,
      },
      fl: [],
      tableData: [],
      api: require("@/api/resources/detail").default,
      isMB: this.$store.state.isMB,
      rules: {
        
      },
      uploadUrl:"/api/Common/UploadPicture",
    };
  },
  methods: {
    onCreateOpened(data) {
    },
    onDetailsOpened(data) {
     
      this.loading(true);
      this.api.getChecklogs({InfoId: this.data.RecordId}).then(res => {
        this.loading(false);
        if(res.Code==0) this.tableData = res.Data;
      })
    },
   
    pass() {
      this.$confirm("确认通过吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.loading(true);
            this.api.pass(this.data.RecordId).then(res => {
              this.loading(false);
              if(res.Code==0) {
                this.$message.success(res.Msg);
                this.$emit("close-saved");
                this.close(true);
              } else {
                this.$message.error(res.Msg);
              }
            })
        })
        .catch(() => {});
    },
    noPass() {
      this.$prompt("请输入不通过原因", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",       
        dangerouslyUseHTMLString:true,
        inputPlaceholder: '请输入不通过原因'
      })
        .then(({value}) => {
          this.loading(true);
            this.api.noPass({Id:this.data.RecordId,CheckMsg:value}).then(res => {
              this.loading(false);
              if(res.Code==0) {
                this.$message.success(res.Msg);
                this.$emit("close-saved");
                this.close(true);
              } else {
                this.$message.error(res.Msg);
              }
            })
        })
        .catch(() => {});
    },
    cancel() {
      this.$confirm("确认撤销审核吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.loading(true);
            this.api.cancelReview(this.data.RecordId).then(res => {
              this.loading(false);
              if(res.Code==0) {
                this.$message.success(res.Msg);
                this.$emit("close-saved");
                this.close(true);
              } else {
                this.$message.error(res.Msg);
              }
            })
        })
        .catch(() => {});
    },
    onBeforeSave() {
      return false;
    },
    onClosed() {
      this.tableData = [];
      this.fl = [];
    },
  }
};
</script>
<style lang="scss">
.file-text2{
  .el-upload--text {
    display: none;
  }
  .el-upload-list__item-name {
    margin-top: -8px;
  }
}
</style>